import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Typography, Button, Grid, Autocomplete, TextField } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { PageContainer } from '../../component/styled/PageContainer'
import moment from 'moment'
import { useSendBulkPayoutEmails, useGetSalesCommissionsPayout } from '../../api/sales-commission'
import { useSnackbar } from 'notistack'
import SendIcon from '@mui/icons-material/Send'
import { ref } from 'yup'

const getLast12Months = () => {
  const months = []
  const now = moment()

  for (let i = 0; i < 12; i++) {
    const date = moment(now).subtract(i, 'months')
    months.push({ label: date.format('MMMM YYYY'), value: date.format('MMYYYY') })
  }

  return months
}

export const Payout = () => {
  const monthOptions = getLast12Months()
  const [open, setOpen] = useState(false)
  const [monthYear, setMonthYear] = useState(monthOptions[0].value)

  const { mutateAsync } = useSendBulkPayoutEmails()
  const { data = [], isLoading, refetch } = useGetSalesCommissionsPayout({ monthYear })

  const { enqueueSnackbar } = useSnackbar()

  const handleSendBulkEmail = async () => {
    try {
      await mutateAsync({ monthYear })
      await refetch()
      enqueueSnackbar(
        'Bulk email process started in the background. This may take up to 5 minutes per user. Please check back later for updates.',
        { variant: 'info' }
      )
    } catch (e) {
      const message =
        e?.response?.data?.errors?.[0]?.msg || 'Something went wrong. Please try again.'
      enqueueSnackbar(message, { variant: 'error' })
    }
  }

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Sales Payout</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} paddingTop={5}>
          <Grid item xs={12}>
            <Typography variant='h1'>Sales Payout</Typography>
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <Autocomplete
              options={monthOptions}
              value={monthOptions.find((option) => option.value === monthYear)}
              onChange={(_, { value }) => value && setMonthYear(value)}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} variant='outlined' fullWidth />}
              fullWidth
              disableClearable={true}
            />
            <Button
              variant='contained'
              color='primary'
              onClick={() => setOpen(true)}
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              size='large'
            >
              IMPORT
            </Button>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
            <Button startIcon={<SendIcon />} onClick={handleSendBulkEmail}>
              Send Payout Emails
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table
              monthYear={monthYear}
              open={open}
              setOpen={setOpen}
              data={data}
              isLoading={isLoading}
              refetch={refetch}
            />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
